import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);

export const getSaveProposal = createSelector(
    getModel,
    (model) => model.saveProposal,
);

export const getSaveProposalData = createSelector(
    getSaveProposal,
    (saveProposal) => saveProposal.data,
);

export const getIsSavingProposal = createSelector(
    getSaveProposal,
    (saveProposal) => saveProposal.isSaving,
);

export const getSaveProposalErrors = createSelector(
    getSaveProposal,
    (saveProposal) => saveProposal.errors,
);

export const getIsInitializing = createSelector(
    getModel,
    (model) => model.isInitializing,
);

// PANELS
export const getPanels = createSelector(getModel, (model) => model.panels);

export const getIsFetchingPanels = createSelector(
    getPanels,
    (value) => value.isFetching,
);

export const getPanelsData = createSelector(getPanels, (value) => {
    if (!value.data) return [];
    return value.data.map((panel) => ({ ...panel, watts: panel.max_power }));
});

export const getPanelsErrors = createSelector(
    getPanels,
    (value) => value.errors,
);

// PANEL BRANDS
export const getPanelBrands = createSelector(
    getModel,
    (model) => model.panelBrands,
);

export const getIsFetchingPanelBrands = createSelector(
    getPanelBrands,
    (value) => value.isFetching,
);

export const getPanelBrandsData = createSelector(
    getPanelBrands,
    (value) => value.data || [],
);

export const getPanelBrandsErrors = createSelector(
    getPanelBrands,
    (value) => value.errors,
);

// ROOF TYPES
export const getRoofTypes = createSelector(
    getModel,
    (model) => model.roofTypes,
);

export const getIsFetchingRoofTypes = createSelector(
    getRoofTypes,
    (value) => value.isFetching,
);

export const getRoofTypesData = createSelector(
    getRoofTypes,
    (value) => value?.data || [],
);

export const getRoofTypesErrors = createSelector(
    getRoofTypes,
    (value) => value.errors,
);

// SYSTEM TYPES
export const getSystemTypes = createSelector(
    getModel,
    (model) => model.systemTypes,
);

export const getIsFetchingSystemTypes = createSelector(
    getSystemTypes,
    (value) => value.isFetching,
);

export const getSystemTypesData = createSelector(
    getSystemTypes,
    (value) => value.data,
);

export const getSystemTypesErrors = createSelector(
    getSystemTypes,
    (value) => value.errors,
);
